import React from 'react';
import { ArrayParam, StringParam, useQueryParams } from 'use-query-params';

import { BREADCRUMB_QUERY_PARAM } from '@/components/Breadcrumb/hooks/useBreadcrumb';
import { useFilterManager } from '@/components/FilterManager';

import { getCategoryDefaultSort } from '../../hooks/usePaginatedWidgetFilters/utils';
import { DefaultCategoryId } from './conts';

export const CATEGORY_ID_QUERY_PARAM = 'categoryId';

export function useCategoryQueryParam() {
  const [query, setQuery] = useQueryParams({
    [CATEGORY_ID_QUERY_PARAM]: StringParam,
    [BREADCRUMB_QUERY_PARAM]: ArrayParam,
  });
  const { methods } = useFilterManager({});

  const setCategory = React.useCallback(
    (categoryId: string, breadcrumbs?: string[]) => {
      const queryToSet: Record<string, string | string[]> = {
        [CATEGORY_ID_QUERY_PARAM]: categoryId,
        [BREADCRUMB_QUERY_PARAM]: [],
      };

      if (breadcrumbs?.length) {
        queryToSet[BREADCRUMB_QUERY_PARAM] = breadcrumbs;
      }

      const shouldReplace = !breadcrumbs;
      setQuery(queryToSet, shouldReplace ? 'replace' : 'push');

      if (isDefaultCategory(categoryId)) {
        setTimeout(() => {
          methods.setSort(getCategoryDefaultSort(categoryId));
        }, 50);
      }
    },
    [methods, setQuery],
  );

  return { categoryId: query[CATEGORY_ID_QUERY_PARAM] ?? undefined, setCategoryId: setCategory };
}

export function isDefaultCategory(categoryId: string = DefaultCategoryId.ALL_CONTENT) {
  return [
    DefaultCategoryId.ALL_CONTENT.toString(),
    DefaultCategoryId.POPULAR_CONTENT.toString(),
    DefaultCategoryId.NEW_CONTENT.toString(),
  ].includes(categoryId);
}
